import { useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaWallet,
  FaRegEdit,
} from "react-icons/fa";
import moment from "moment";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getWithdrawlRequest } from "./services/wallet.services";
import Loading from "../../components/spinner/Loading";
import { RiDeleteBin6Line } from "react-icons/ri";
import WalletWithdrawReqDelete from "./WalletWithdrawReqDelete";
import WalletWithdrawalForm from "./WalletWithdrawalForm";

const WithdrawalRequestView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);

  const loading = useAppSelector((state) => state.wallet.loading);
  const withdrawRequestDetails = useAppSelector(
    (state) => state.wallet.withdrawRequestDetails
  );

  useEffect(() => {
    dispatch(getWithdrawlRequest(location?.state?.ID));
  }, []);

  return (
    <>
      <Loading loading={loading} />
      <WalletWithdrawReqDelete ID={location?.state?.ID} />
      <div className="container py-4">
        <div className="d-flex align-items-center mb-4">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-link me-3"
            style={{
              color: "#00a34d",
              background: "white",
              padding: "8px",
            }}
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="mb-0">Withdrawal Request Details</h2>
        </div>

        <div className="card border-0 shadow-sm">
          {!isEdit ? (
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <span
                  className="badge text-white py-2 px-3"
                  style={{
                    backgroundColor:
                      withdrawRequestDetails.WithdrawlStatus === "Pending"
                        ? "goldenrod"
                        : withdrawRequestDetails.WithdrawlStatus === "Rejected"
                        ? "lightcoral"
                        : "#00a34de6",
                    fontSize: "0.9rem",
                  }}
                >
                  {withdrawRequestDetails.WithdrawlStatus}
                </span>
                {withdrawRequestDetails.WithdrawlStatus === "Pending" && (
                  <div>
                    <span>
                      <FaRegEdit
                        className="me-2 traveller-icon"
                        title="Edit"
                        onClick={() => {
                          setIsEdit(true);
                        }}
                      />
                      <RiDeleteBin6Line
                        className="traveller-icon red-color"
                        data-bs-toggle="modal"
                        data-bs-target="#withdrawalrequestdelete"
                        title="Delete"
                        // onClick={() => {
                        //   dispatch(
                        //     setTravellerGUID(traveller?.traveller_information_guid)
                        //   );
                        // }}
                      />
                    </span>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-4">
                    <h5
                      className="mb-3"
                      style={{ color: "rgba(0, 163, 77, 1)" }}
                    >
                      Transaction Details
                    </h5>

                    <div className="d-flex mb-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Request Date</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          {moment(
                            withdrawRequestDetails.RequestDate,
                            "DD/MM/YYYY HH:mm:ss"
                          ).format("DD MMM YYYY, hh:mm A")}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Amount</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          ₹{" "}
                          {withdrawRequestDetails.Amount?.toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                            }
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Withdrawal Date</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          {withdrawRequestDetails.WithdrawDate
                            ? moment(
                                withdrawRequestDetails.WithdrawDate,
                                "DD/MM/YYYY"
                              ).format("DD MMM YYYY")
                            : "-"}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Payment Method</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold text-capitalize">
                          {withdrawRequestDetails?.PaymentType}
                        </p>
                      </div>
                    </div>

                    {/* Payment Method Details */}
                    {withdrawRequestDetails?.PaymentType === "UPI" ? (
                      <div className="d-flex mb-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">UPI Details</p>
                        </div>
                        <div>
                          <div className="d-flex align-items-center">
                            {/* {getUpiIcon()} */}
                            <p className="mb-0 fw-bold">
                              {withdrawRequestDetails?.UPIID}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : withdrawRequestDetails?.PaymentType === "Bank" ? (
                      <>
                        <div className="d-flex mb-3">
                          <div style={{ width: "150px" }}>
                            <p className="text-muted mb-0">Bank Name</p>
                          </div>
                          <div>
                            <p className="mb-0 fw-bold">
                              {withdrawRequestDetails?.BankName || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-3">
                          <div style={{ width: "150px" }}>
                            <p className="text-muted mb-0">Account Number</p>
                          </div>
                          <div>
                            <p className="mb-0 fw-bold">
                              {withdrawRequestDetails?.AccountNo || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-3">
                          <div style={{ width: "150px" }}>
                            <p className="text-muted mb-0">IFSC Code</p>
                          </div>
                          <div>
                            <p className="mb-0 fw-bold">
                              {withdrawRequestDetails?.IFSCCode || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-3">
                          <div style={{ width: "150px" }}>
                            <p className="text-muted mb-0">Branch Name</p>
                          </div>
                          <div>
                            <p className="mb-0 fw-bold">
                              {withdrawRequestDetails?.BranchName || "-"}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="d-flex">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Remarks</p>
                      </div>
                      <div>
                        <p className="mb-0">
                          {withdrawRequestDetails.Remarks || "-"}
                        </p>
                      </div>
                    </div>

                    {withdrawRequestDetails.WithdrawRemarks && (
                      <div className="d-flex mt-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">Admin Remarks</p>
                        </div>
                        <div>
                          <p className="mb-0">
                            {withdrawRequestDetails.WithdrawRemarks || "-"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right column - User details */}
                <div className="col-md-6">
                  <div className="mb-4">
                    <h5
                      className="mb-3"
                      style={{ color: "rgba(0, 163, 77, 1)" }}
                    >
                      User Details
                    </h5>

                    <div className="d-flex align-items-center mb-3">
                      <FaUser
                        className="me-2"
                        style={{ color: "rgba(205, 200, 36, 1)" }}
                      />
                      <p className="mb-0 fw-bold">
                        {withdrawRequestDetails.first_name}{" "}
                        {withdrawRequestDetails.last_name}
                      </p>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <FaPhone
                        className="me-2"
                        style={{ color: "rgba(205, 200, 36, 1)" }}
                      />
                      <p className="mb-0 fw-bold">
                        {withdrawRequestDetails.mobile_no}
                      </p>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <FaEnvelope
                        className="me-2"
                        style={{ color: "rgba(205, 200, 36, 1)" }}
                      />
                      <p className="mb-0 fw-bold">
                        {withdrawRequestDetails.email_id}
                      </p>
                    </div>
                  </div>

                  <div>
                    <h5
                      className="mb-3"
                      style={{ color: "rgba(0, 163, 77, 1)" }}
                    >
                      Wallet Details
                    </h5>

                    <div className="d-flex align-items-center mb-3">
                      <FaWallet
                        className="me-2"
                        style={{ color: "rgba(205, 200, 36, 1)" }}
                      />
                      <div>
                        <p className="mb-1 fw-bold">
                          ₹{" "}
                          {withdrawRequestDetails.wallet_balance?.toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                            }
                          )}
                        </p>
                        <p className="text-muted mb-0">
                          (Refundable: ₹{" "}
                          {withdrawRequestDetails.refundable_walletamount?.toLocaleString(
                            "en-IN"
                          )}{" "}
                          | Non-refundable: ₹{" "}
                          {withdrawRequestDetails.non_refundable_walletamount?.toLocaleString(
                            "en-IN"
                          )}
                          )
                        </p>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Wallet Created On</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          {moment(
                            withdrawRequestDetails.wallet_createdon,
                            "DD/MM/YYYY"
                          ).format("DD MMM YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body p-4">
              <WalletWithdrawalForm
                ID={location.state?.ID}
                setIsEdit={setIsEdit}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WithdrawalRequestView;
